import Timer from "../timer/Timer.js";
import ReCAPTCHA from "react-google-recaptcha";
import TokenCarousel from "../token-carousel/TokenCarousel.js"; 

import "./ProductModal.css";

function ProductModal({ product, isActive, toggle, status, reservedTimer, expireReservation, reserveProduct, setCaptchaUserResponseToken }) {
  if (status === "LOADING" || status === "CAPTCHA") {
    return <PlaceholderLoadingModal reserveProduct={reserveProduct} product={product} isActive={isActive} toggle={toggle} status={status} setCaptchaUserResponseToken={setCaptchaUserResponseToken} />;
  }

  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value).then(function () {
    }, function () {
      console.log("copy failed");
    });
  }


  const productData = product.data || {};
  const tokens = productData.tokens || null;

  const { address, price_ada, error_code, error_message } = productData.payload || {};

  const qrAddress = `https://chart.googleapis.com/chart?chs=300x300&cht=qr&choe=UTF-8&chl=web+cardano:${address}?amount=${price_ada}`

  return (
    <div id="nft-modal" className={`modal ${isActive && "is-active"}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {product.name} {product.bundleName ? ` | ${product.bundleName}` : ""}
          </p>
        </header>
        <section className="modal-card-body">
          {status === "SERVER_ERROR" &&
            <div id="server-error" className="nft-modal-section">
              Server was unable to process the request. Please wait and try again later.
            </div>}

          {status === "SOLD_OUT" &&
            <div id="server-error" className="nft-modal-section">
              All tokens are reserved or sold Out! Refresh the page to see if any reservations have expired.
            </div>}

          {status === "COOLDOWN" && error_code === 1 &&
            <div id="nft-reserve-error" className="nft-modal-section">
              <p id="reserve-error-message">{error_message || "Unable to Reserve Token. Please try again"}</p>
            </div>}

          {status === "EXPIRED" &&
            <div id="nft-expired" className="nft-modal-section">
              <p>Reservation expired. Close this pop-up and try again!</p>
            </div>
          }
          {status === "RESERVED" && !error_code &&
            <div id="nft-reserved" className="nft-modal-section">

              <div className="columns is-vcentered">
                <div className="column is-half">
                  <figure>
                    <img id="cardano-url-qr" width="300px" height="300px" src={qrAddress} alt="Address and Ada QR" />
                  </figure>
                </div>
                <div className="column is-half">
                  <Timer duration={reservedTimer} expireReservation={expireReservation} />
                  <label className="label">Send to:</label>
                  <div className="field has-addons">
                    <div className="control is-expanded">
                      <input id="send-to-address" className="input" value={address} readOnly />
                    </div>
                    <div className="control">
                      <button id="address-copy" className="button" onClick={() => copyToClipboard(address)}>Copy</button>
                    </div>
                  </div>

                  <label className="label">Price:</label>
                  <div className="field has-addons">
                    <div className="control  is-expanded">
                      <input id="price-ada" className="input" value={price_ada} readOnly />
                    </div>
                    <div className="control">
                      <button
                        id="price-copy"
                        className="button"
                        onClick={() => copyToClipboard(price_ada)}>
                        Copy
                      </button>
                    </div>
                  </div>
                </div>

              </div>
              <div className="columns">
                <div className="column">
                  <div className="column notification">
                    <p>Please send exactly the amount of ADA shown above to the address displayed. The time remaining in your reservation is shown above.</p>
                  </div>
                  <div className="column notification">
                    <p>Please keep this window open until your transaction has been successfully processed.</p>
                  </div>
                </div>

              </div>
              <div className="columns">
                <div className="column">
                  <div className="notification is-warning">
                    <p><strong>Warning! Do not send ADA from an exchange!</strong></p>
                    <p>You must use a Cardano Shelley-Era wallet like Daedalus, Yoroi, or ADALite.</p>
                  </div>
                </div>
              </div>
            </div>}

          {status === "SUCCESS" && <TokenCarousel tokens={tokens} />}
        </section>
        <footer id="nft-modal-footer" className="modal-card-foot">
          {status !== "SUCCESS" &&
            <button className="button close" onClick={() => {
              toggle()
              expireReservation()
            }}>Close</button>}
          {status === "SUCCESS" &&
            <button
              id="nft-success-regen-btn"
              className="button secondary-btn"
              onClick={() => {
                toggle()
                expireReservation()
              }}>
              Get more!</button>}
          {/* <!-- <div className="level">
                <div className="level-left">
                    <div className="level-item">
                        <button className="button close">Close</button>
                    </className>
                </div>

                <div className="level-right">
                    <div className="level-item">
                        <button id="nft-success-regen-btn" className="button secondary-btn">Get more!</button>
                    </className>
                </div>
            </div> --> */}

        </footer>
      </div>
    </div>
  );
}

function PlaceholderLoadingModal({ product, isActive, toggle, status, reserveProduct, setCaptchaUserResponseToken }) {
  return (
    <div id="nft-modal" className={`modal ${isActive && "is-active"}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {product.name} {product.bundleName ? ` | ${product.bundleName}` : ""}
          </p>
        </header>
        <section className="modal-card-body">
          <div id="nft-loading" className="nft-modal-section">
            <div className="columns has-text-centered is-centered">
              <div id="captcha-container" className="column">
                {/* {status === "LOADING" &&
                  <p className="title is-2">Reserving NFT...</p>} */}

                {(status === "CAPTCHA" || status === "LOADING") && <ReCAPTCHA
                  sitekey="6Le8dK8cAAAAAG23PLRcBed_aO43jw_ofQkzTP9u"
                  onChange={(userToken) => {
                    setCaptchaUserResponseToken(userToken);
                    reserveProduct(product);
                  }}
                />}
              </div>
            </div>
          </div>
        </section>
        <footer id="nft-modal-footer" className="modal-card-foot">
          <button className="button close" onClick={toggle}>Close</button>
        </footer>
      </div>
    </div>
  );
}
export default ProductModal;